import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { compose, graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'

import { styles } from './styles'
import Title from '../../components/Title'
import { withContext } from '../../context'
import {
  beforeUpload,
  compressFile,
  getPlaceholderDetail,
  getPlaceholderName,
  isMobile
} from '../../utils'
import { Col, Form, Input, Modal, Row, Space, Upload } from 'antd'
import {
  ButtonUploadDiv,
  CircularBinImg,
  SuccessIconImg
} from '../SignupBin/AddBin'
import AddIcon from '../../assets/icons/Add_image.png'
import { ButtonEx } from '../HeroLocations/index.style'
import Card from '@material-ui/core/Card'
import { useDeepEffect } from '../../utils/hooks'
import _, { isEmpty, isUndefined, remove, some } from 'lodash'
import axios from 'axios'
import { CloseCircleFilled } from '@ant-design/icons'
import AddBinIcon from '../../assets/icons/bin_1.png'
import { CardEx, Text, CardContentEx } from '../../shared.style'
import { RESPONSE_MESSAGE } from '../../utils/constants'
import SuccessIcon from '../../assets/icons/success.png'
import SuccessDuplicateIcon from '../../assets/icons/success_duplicate.png'
import BinDelete from './BinDelete'
import DetailSelection from '../../components/DetailSelection'

export const AccountBin = ({
  history: { push },
  context: { state },
  me
}) => {
  const [form] = Form.useForm()
  const [circularBinMaterials, setCircularBinMaterials] = useState([])
  const [materialBinList, setMaterialBinList] = useState([])
  const [bins, setBins] = useState([])
  const [fileList, setFileList] = useState([])
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [detailKey, setDetailKey] = useState(null)
  const [visible, setVisible] = useState(false)
  const [removeData, setRemoveData] = useState({})

  async function fetchData() {
    try {
      setBins([])
      setMaterialBinList([])
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/bin/heroBin/${me.id}`
      )

      setBins(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function fetchCircularBins() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/product/circularBinMaterial`
      )
      setCircularBinMaterials(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    fetchData()
    fetchCircularBins()
  }, [])

  useDeepEffect(() => {
    if (!isEmpty(bins)) {
      const formBins = bins.map((item) => {
        return {
          name: item.name,
          description: item.description,
          image: [{ url: item.image }]
        }
      })

      setMaterialBinList((prevState) => {
        bins.forEach((bin, index) => {
          const arr = []
          if (index !== 0) {
            bin.materialDtoList.forEach((material) => {
              arr.push({
                id: material.id,
                name: material.name,
                commonName: material.commonName
              })
            })
          }

          const arrData = {
            id: bin.id,
            materialBins: arr
          }
          prevState.push(arrData)
        })
        return [...prevState]
      })

      setFileList((prevState) => {
        formBins.forEach((item, index) => {
          prevState.push({
            key: index,
            value: {
              url: item.image
            }
          })
        })

        return [...prevState]
      })

      form.setFieldsValue({
        bins: formBins
      })
    }
  }, [bins])

  useDeepEffect(() => {
    if (!isEmpty(circularBinMaterials)) {
      circularBinMaterials.forEach((item) => {
        materialBinList.forEach((prevState) => {
          prevState.materialBins.push(item)
        })
      })
    }
  }, [])

  const addRow = async (add) => {
    await setMaterialBinList((prevState) => {
      const data = {
        id: 0,
        materialBins: []
      }
      prevState.push(data)
      return [...prevState]
    })
    await add()
  }

  const onClickItem = (circularBin, index) => {
    const isDuplicate = _.some(materialBinList, (material, idx) => {
      if (idx !== index) {
        return _.some(material.materialBins, (item) => {
          return item.id === circularBin.id
        })
      } else {
        return false
      }
    })

    if (!isDuplicate) {
      setMaterialBinList((prevState) => {
        prevState.forEach((item, idx) => {
          if (index === idx) {
            const findId = _.some(item.materialBins, ['id', circularBin.id])
            if (findId) {
              _.remove(item.materialBins, ['id', circularBin.id])
            } else {
              item.materialBins.push(circularBin)
            }
          }
        })
        return [...prevState]
      })
    }
  }

  const renderItemActive = (item, index) => {
    let active = false
    materialBinList.forEach((bin, idx) => {
      const isDuplicate = _.some(bin.materialBins, (material) => {
        return material.id === item.id
      })

      if (isDuplicate) {
        active = true
      } else {
        if (bin.id === index) {
          bin.materialBins.forEach((material) => {
            if (material.id === item.id) {
              active = true
            }
          })
        }
      }
    })

    return active
  }

  const renderSuccessActive = (item, index) => {
    let active = false
    materialBinList.forEach((bin, idx) => {
      if (idx !== 0) {
        const isDuplicate = _.some(bin.materialBins, (material) => {
          return material.id === item.id
        })

        if (isDuplicate) {
          active = idx !== index
        } else {
          if (bin.id === index) {
            bin.materialBins.forEach((material) => {
              if (material.id === item.id) {
                active = true
              }
            })
          }
        }
      }
    })

    return active ? SuccessDuplicateIcon : SuccessIcon
  }

  const onFinish = async (values) => {
    const binRequestList = []
    let checkMaterial = true
    for (const [, item] of values.bins.entries()) {
      const binData = {
        name: item.name,
        description: item.description || '',
        materialIdList: []
      }

      if (!isUndefined(item.image)) {
        const img = item.image[0]
        const formData = new FormData()

        if (img.originFileObj) {
          try {
            formData.append('image', await compressFile(img.originFileObj))
            const res = await axios.post(
              process.env.REACT_APP_API_ENDPOINT + `/bin/image`,
              formData,
              {
                headers: {
                  'content-type': 'multipart/form-data'
                }
              }
            )

            const { data } = res
            binData.image = data.url
          } catch (err) {
            console.log(err)
          }
        } else {
          binData.image = img.url
        }

        binRequestList.push(binData)
      }
    }

    binRequestList.forEach((item, index) => {
      materialBinList.forEach((materialBin, idx) => {
        item.heroId = me.id
        if (index === idx) {
          if (!isEmpty(materialBin.materialBins)) {
            materialBin.materialBins.forEach((materialBinItem) => {
              item.materialIdList.push(materialBinItem.id)
              item.id = materialBin.id
            })
          } else {
            item.id = materialBin.id
            if (idx !== 0) {
              Modal.warning({
                content: `คุณยังไม่ได้เลือกวัสดุรีไซเคิลให้ถังที่ ${idx + 1}`
              })
              checkMaterial = false
            }
          }
        }
      })
    })

    if (checkMaterial) {
      try {
        await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/bin/updateBin`,
          binRequestList
        )
        await fetchData()
        Modal.success({
          content: RESPONSE_MESSAGE.SUCCESS
        })
      } catch (err) {
        Modal.error({
          content: RESPONSE_MESSAGE.FAIL
        })
      }
    }
  }

  const checkBinImg = (key) => {
    const formBins = form.getFieldValue('bins')
    if (!isUndefined(formBins[key])) {
      return isEmpty(formBins[key].image)
    } else {
      return true
    }
  }

  const handleBinChange = async (info, key) => {
    setFileList((prevState) => {
      const result = some(fileList, (item) => {
        return item.key === key
      })

      if (!result) {
        prevState.push({
          key: key,
          value: info.fileList[0]
        })
      } else {
        remove(fileList, (item) => {
          return item.key === key
        })
      }

      return [...prevState]
    })
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }

    return e && e.fileList
  }

  const onClickDelete = (removeRow, name, index) => {
    setVisibleDelete(true)
    setRemoveData({
      removeRow,
      name,
      index
    })
  }

  const onCloseDelete = () => {
    setVisibleDelete(false)
    setRemoveData({})
  }

  const removeBin = async () => {
    const { removeRow, name, index } = removeData
    await removeRow(name)
    await setMaterialBinList((prevState) => {
      remove(prevState, (item, idx) => {
        return idx === index
      })
      return [...prevState]
    })
    await deleteRow()
    await onCloseDelete()
  }

  const deleteRow = async () => {
    const bins = form.getFieldValue('bins')
    const binRequestList = []
    for (const [, item] of bins.entries()) {
      if (item) {
        const binData = {
          name: item.name,
          description: item.description || '',
          materialIdList: []
        }

        if (!isUndefined(item.image)) {
          const img = item.image[0]
          const formData = new FormData()

          if (img.originFileObj) {
            formData.append('image', img.originFileObj)
            try {
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/bin/image`,
                formData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )

              const { data } = res
              binData.image = data.url
            } catch (err) {
              console.log(err)
            }
          } else {
            binData.image = img.url
          }

          binRequestList.push(binData)
        }
      }
    }

    binRequestList.forEach((item, index) => {
      materialBinList.forEach((materialBin, idx) => {
        if (index === idx) {
          materialBin.materialBins.forEach((materialBinItem) => {
            item.materialIdList.push(materialBinItem.id)
          })
          item.heroId = me.id
          item.id = materialBin.id
        }
      })
    })

    try {
      await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/bin/updateBin`,
        binRequestList
      )
      await fetchData()
      Modal.success({
        content: RESPONSE_MESSAGE.SUCCESS
      })
    } catch (err) {
      Modal.error({
        content: RESPONSE_MESSAGE.FAIL
      })
    }
  }

  const openModal = (key) => {
    setVisible(true)
    setDetailKey(key)
  }

  const onOk = () => {
    setVisible(false)
    setDetailKey(null)
  }

  const onCancel = () => {
    setVisible(false)
    setDetailKey(null)
  }
  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => push(`/`)}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            ถังขยะของฉัน
          </Typography>
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
        {state.uploading ? (
          <LinearProgress />
        ) : (
          <div style={{ height: '4px' }} />
        )}
      </AppBar>
      <Title name="ถังขยะของฉัน" />
      <Card elevation={isMobile ? 0 : 1} square>
        <CardContentEx>
          <Form form={form} onFinish={onFinish} labelCol={{ span: 6 }}>
            <Form.List name="bins">
              {(fields, { add, remove }) => (
                <div>
                  {fields.map(
                    ({ key, name, fieldKey, ...restField }, index) => (
                      <CardEx
                        key={key}
                        style={{
                          marginBottom: 5,
                          backgroundColor: index === 0 ? '#ededed' : 'white'
                        }}>
                        <Row gutter={8} style={{ marginBottom: 10 }}>
                          <Col span={16}>
                            {key === 0 ? (
                              <span style={{ color: '#6ebf4b' }}>{`ถังขยะที่ ${
                                index + 1
                              } สำหรับใส่วัสดุที่ไม่มีถังอื่นรองรับ`}</span>
                            ) : (
                              <span style={{ color: '#6ebf4b' }}>{`ถังขยะที่ ${
                                index + 1
                              }`}</span>
                            )}
                          </Col>
                          <Col span={8}>
                            <Row justify="end">
                              {index !== 0 && index !== 1 && (
                                <CloseCircleFilled
                                  onClick={() =>
                                    onClickDelete(remove, name, index)
                                  }
                                />
                              )}
                            </Row>
                          </Col>
                        </Row>
                        <Form.Item
                          {...restField}
                          name={[name, 'image']}
                          fieldKey={[fieldKey, 'image']}
                          label="รูปภาพถังขยะ"
                          rules={[
                            {
                              required: true,
                              message: 'เลือกรูปภาพถังขยะ'
                            }
                          ]}
                          valuePropName="fileList"
                          getValueFromEvent={normFile}>
                          <Upload
                            maxCount={1}
                            // fileList={[fileList[fieldKey].value]}
                            listType="picture"
                            beforeUpload={beforeUpload}
                            onChange={(info) =>
                              handleBinChange(info, fieldKey)
                            }>
                            {checkBinImg(index) && (
                              <ButtonUploadDiv>
                                <img
                                  src={AddIcon}
                                  alt=""
                                  width={80}
                                  height={80}
                                />
                              </ButtonUploadDiv>
                            )}
                          </Upload>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          label="ชื่อถังขยะ"
                          name={[name, 'name']}
                          fieldKey={[fieldKey, 'name']}
                          rules={[
                            { required: true, message: 'กรอกชื่อถังขยะ' }
                          ]}>
                          <Input placeholder={getPlaceholderName(index)} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          label="คำอธิบายก่อนทิ้ง"
                          name={[name, 'description']}
                          fieldKey={[fieldKey, 'description']}>
                          <Input.TextArea
                            rows={2}
                            placeholder={getPlaceholderDetail(index)}
                          />
                        </Form.Item>
                        {key !== 0 && (
                          <div>
                            <Row>
                              <Space size="small">
                                <span style={{ color: 'red' }}>*</span>
                                <span>เลือกวัสดุที่ถังรองรับ</span>
                              </Space>
                            </Row>
                            <Row gutter={8}>
                              {circularBinMaterials.map((item, idx) => {
                                return (
                                  <Col span={6} key={idx}>
                                    {renderItemActive(item, index) && (
                                      <SuccessIconImg
                                        src={renderSuccessActive(item, index)}
                                        alt=""
                                      />
                                    )}
                                    <CircularBinImg
                                      active={renderItemActive(item, index)}
                                      onClick={() => onClickItem(item, index)}>
                                      <Row justify="center">
                                        <img
                                          style={{ borderRadius: '50%' }}
                                          src={item.image}
                                          alt=""
                                          width={64}
                                          height={64}
                                        />
                                      </Row>
                                      <Row justify="center">
                                        <span
                                          style={{
                                            fontSize: 14,
                                            textAlign: 'center'
                                          }}>
                                          {item.name}
                                        </span>
                                      </Row>
                                    </CircularBinImg>
                                  </Col>
                                )
                              })}
                            </Row>
                            <Row justify="center" gutter={8}>
                              <Col>
                                <Text>หรือ</Text>
                              </Col>
                              <Col>
                                <Text
                                  color="#6ebf4b"
                                  cursor="pointer"
                                  bold
                                  onClick={() => openModal(index)}>
                                  เลือกอย่างละเอียด
                                </Text>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </CardEx>
                    )
                  )}
                  <CardEx>
                    <Form.Item>
                      <ButtonUploadDiv onClick={() => addRow(add)}>
                        <Row justify="center">
                          <img src={AddBinIcon} alt="" width={80} height={80} />
                        </Row>
                        <Row type="flex" justify="center">
                          <span>เพิ่มถังขยะของ Circular Bin</span>
                        </Row>
                      </ButtonUploadDiv>
                    </Form.Item>
                  </CardEx>
                </div>
              )}
            </Form.List>
            <Row justify="center" style={{ marginTop: 15 }}>
              <Space>
                <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
                  บันทึกข้อมูล
                </ButtonEx>
              </Space>
            </Row>
          </Form>
        </CardContentEx>
      </Card>
      <BinDelete
        visible={visibleDelete}
        onOk={removeBin}
        onCancel={onCloseDelete}
      />
      <DetailSelection
        materialBinList={materialBinList}
        detailKey={detailKey}
        onClickItem={onClickItem}
        onOk={onOk}
        visible={visible}
        onCancel={onCancel}
      />
    </React.Fragment>
  )
}

AccountBin.propTypes = {
  history: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired
}

export default compose(
  withRouter,
  withContext
)(AccountBin)



// WEBPACK FOOTER //
// ./src/pages/AccountBin/index.js